<script setup>
import {reactive,onMounted,computed} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const data = reactive({
  headers: [
    { title: 'Date/Time', key: 'time' },
    { title: 'Sent By', key: 'created_by'},
    { title: 'Sent To', key: 'sentto' },
    { title: 'Message', key: 'message' },
    { title: 'Claim Number', key: 'claimnumber' },
    { title: 'Age', key: 'age' },
    { title: 'Person Insured', key: 'insuredname' },
    { title: 'Client', key: 'client' },
  ],
  loading: false,
  search: null,
  messages: [],
  timezone: new Date()
})

const csvData = computed(()=>{
  // CSV File
  return data.messages.map((item) => ({
    ...item,
    message: item.message,
    name: item.name,
    time: formatTimestampByLocale(item.time),
  }))
})

const csvExport = (arrData) => {
  // CSV File
  let csvContent = 'data:text/csv;charset=utf-8,'
  csvContent += [
    Object.keys(arrData[0]).join(';'),
    ...arrData.map((item) => Object.values(item).join(';')),
  ]
      .join('\n')
      .replace(/(^\[)|(\]$)/gm, '')

  const data = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', 'export.csv')
  link.click()
}

// formatTimestampByLocale(timestamp) {
//   const date = new Date(timestamp)
//   return date.toLocaleString()
// },
const formatTimestampByLocale = (timestamp) => {
  const date = new Date(timestamp)
  const timeOptions = {
    hour12: true,
    hour: "numeric",
    minute: "2-digit",
  }
  const dateOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    timeZoneName:'short'
  }
  return date.toLocaleString('en', { ...dateOptions, ...timeOptions })
}

const getTimezone = (timezoneShortened) => {
  const tzName = data.timezone
  return tzName.toLocaleString('en', {timeZoneName:'short'}).split(' ').pop();
}

const update = (item) => {
  data.loading = true
  ApiWrapper.post('messaging', 'update-message', {
        id: item.id,
        status: item.is_read,
      })
      .then((response) => {
        data.loading = false
        ToastUtil.successMsg('Updated message');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

const listAll = () => {
  data.loading = true
  ApiWrapper.post('messaging', 'profile-messages', {
        personId: props.contextIdA
      })
      .then((response) => {
        data.messages = response.messages;
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false
      })
}

onMounted(()=>{
  listAll()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>All User's Messages</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-icon @click="csvExport(csvData)" v-if="data.messages.length"> mdi-file-download </v-icon>
        <v-spacer></v-spacer>
        <v-text-field density="compact" v-model="data.search" append-icon="mdi-magnify" label="Search" single-line hide-details
                      class="ml-4"></v-text-field>
      </v-toolbar>
      <v-data-table :items="data.messages" :headers="data.headers" :search="data.search" :items-per-page="1" :items-per-page-options="[1, 5, 10]">
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{ item.claimnumber }}
          </RouterLink>
        </template>
        <template v-slot:[`item.client`]="{ item }">
          <RouterLink :to="`/client/${item.clientid}`">
            {{ item.client }}
          </RouterLink>
        </template>
        <template v-slot:[`item.time`]="{ item }">
          {{ formatTimestampByLocale(item.time) }}
          <!-- {{ formatTimestampByLocale(item.time) }} - {{ getTimezone(timezone) }} -->
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
[v-cloak] {
  display: none;
}
.container {
  padding: 5px;
}
</style>